import './trailmap.js'

(async function () {
    function containsIgnoreCaseAndAccents(targetString, searchString) {
        const normalizedTarget = targetString
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        const normalizedSearch = searchString
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        const ss = normalizedSearch.replace(/\s+/g, " ").split(" ")

        let result = false;
        for (let i = 0; i < ss.length; i++) {
            if (ss[i] && normalizedTarget.includes(ss[i])) {
                result = true;
            }
        }

        return result;
    }

    function filterResults(trailfinder) {
        const trailsEl = trailfinder.querySelector(".trails")
        const resultNumEl = trailfinder.querySelector(".n-results").querySelector(".value")
        const someResultsEl = trailfinder.querySelector(".some-results")
        const noResultsEl = trailfinder.querySelector(".no-results")
        const trails = trailsEl.querySelectorAll(".trail")
        const filters = trailfinder.querySelector(".filters")

        const search = filters == null ? null : filters.querySelector("input.search")
        const distances = filters == null ? null : filters.querySelectorAll(".distances > button")
        const difficulties = filters == null ? null : filters.querySelectorAll(".difficulties > button")
        const uses = filters == null ? null : filters.querySelectorAll(".uses > button")
        const locations = filters == null ? null : filters.querySelectorAll(".locations > button")
        const dogs = filters == null ? null : filters.querySelectorAll(".dogs > button")

        const trailsMatchingDistance = trailsMatchingDistances(trails, distances)
        const trailsMatchingSearch = trailsMatchingSearchValue(trails, search)
        const trailsMatchingDifficulty = trailsMatchingDifficulties(trails, difficulties)
        const trailsMatchingUse = trailsMatchingUses(trails, uses)
        const trailsMatchingLocation = trailsMatchingLocations(trails, locations)
        const trailsMatchingDog = trailsMatchingDogs(trails, dogs)

        const filteredTrails = findCommonElements(trailsMatchingDistance, trailsMatchingSearch, trailsMatchingDifficulty, trailsMatchingUse, trailsMatchingLocation, trailsMatchingDog)
        handleFilterTrailVisibility(trails, filteredTrails)

        resultNumEl.innerText = filteredTrails.length

        if (filteredTrails.length == 0) {
            noResultsEl.classList.remove("hide")
            someResultsEl.classList.add("hide")
        } else {
            noResultsEl.classList.add("hide")
            someResultsEl.classList.remove("hide")
        }
        trailfinder.map.setTrails(trails)
    }

    function handleFilterTrailVisibility(trails, filteredTrails) {
        for (let i = 0; i < trails.length; i++) {
            const trail = trails[i]
            if (filteredTrails.includes(trail)) {
                trail.style.display = "block"
                trail.classList.add("visible")
            } else {
                trail.style.display = "none"
                trail.classList.remove("visible")
            }
        }
    }

    function findCommonElements(arr1, arr2, arr3, arr4, arr5, ar6) {
        return arr1.filter(element =>
            arr2.includes(element) &&
            arr3.includes(element) &&
            arr4.includes(element) &&
            arr5.includes(element) &&
            ar6.includes(element)
        );
    }

    function trailsMatchingSearchValue(trails, search) {
        let result = []
        for (let i = 0; i < trails.length; i++) {
            if (search.value) {
                if (containsIgnoreCaseAndAccents(trails[i].dataset.summary, search.value)) {
                    result.push(trails[i])
                }
            } else {
                result.push(trails[i])
            }
        }
        return result
    }

    function anyNodeActive(nodes) {
        let result = false;
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].classList.contains("active")) {
                result = true;
                break;
            }
        }
        return result;
    }

    function asArray(nodes) {
        let result = []
        for (let i = 0; i < nodes.length; i++) {
            result.push(nodes[i])
        }
        return result
    }

    function trailsMatchingDogs(trails, dogs) {
        let result = []
        if (anyNodeActive(dogs)) {
            for (let i = 0; i < trails.length; i++) {
                const trail = trails[i]
                for (let d = 0; d < dogs.length; d++) {
                    const dog = dogs[d]
                    if (dog.classList.contains("active")) {
                        const dogValue = dog.innerText == "Yes" ? "true" : "false"
                        if (trails[i].dataset.dog + "" == dogValue) {
                            result.push(trail)
                        }
                    }
                }
            }
        } else {
            result = asArray(trails)
        }
        return result;
    }

    function trailsMatchingLocations(trails, locations) {
        let result = []
        if (anyNodeActive(locations)) {
            for (let i = 0; i < trails.length; i++) {
                const trail = trails[i]
                for (let d = 0; d < locations.length; d++) {
                    const location = locations[d]
                    if (location.classList.contains("active")) {
                        const locationValue = location.innerText
                        if (trails[i].dataset.location.includes(locationValue) && !result.includes(trail)) {
                            result.push(trail)
                        }
                    }
                }
            }
        } else {
            result = asArray(trails)
        }
        return result;
    }

    function trailsMatchingUses(trails, uses) {
        let result = []
        if (anyNodeActive(uses)) {
            for (let i = 0; i < trails.length; i++) {
                const trail = trails[i]
                for (let d = 0; d < uses.length; d++) {
                    const use = uses[d]
                    if (use.classList.contains("active")) {
                        const useValue = use.innerText
                        if (trails[i].dataset.use.includes(useValue) && !result.includes(trail)) {
                            result.push(trail)
                        }
                    }
                }
            }
        } else {
            result = asArray(trails)
        }
        return result;
    }


    function trailsMatchingDifficulties(trails, difficulties) {
        let result = []
        if (anyNodeActive(difficulties)) {
            for (let i = 0; i < trails.length; i++) {
                const trail = trails[i]
                for (let d = 0; d < difficulties.length; d++) {
                    const difficulty = difficulties[d]
                    if (difficulty.classList.contains("active")) {
                        const difficultyValue = difficulty.innerText
                        if (difficultyValue == trails[i].dataset.difficulty) {
                            result.push(trail)
                        }
                    }
                }
            }
        } else {
            result = asArray(trails)
        }
        return result;
    }

    function trailsMatchingDistances(trails, distances) {
        let result = []
        if (anyNodeActive(distances)) {
            for (let i = 0; i < trails.length; i++) {
                const trail = trails[i]
                for (let d = 0; d < distances.length; d++) {
                    const distance = distances[d]
                    if (distance.classList.contains("active")) {
                        const min = distance.dataset.min
                        const max = distance.dataset.max
                        const distValue = parseFloat(trail.dataset.distance + "")
                        if (min < distValue && max > distValue) {
                            result.push(trail)
                        }
                    }
                }
            }
        } else {
            result = asArray(trails)
        }
        return result;
    }


    function clearFilters(filters) {
        const distances = filters == null ? null : filters.querySelectorAll(".distances > button")
        removeSelections(distances)
        const difficulties = filters == null ? null : filters.querySelectorAll(".difficulties > button")
        removeSelections(difficulties)
        const uses = filters == null ? null : filters.querySelectorAll(".uses > button")
        removeSelections(uses)
        const locations = filters == null ? null : filters.querySelectorAll(".locations > button")
        removeSelections(locations)
        const dogs = filters == null ? null : filters.querySelectorAll(".dogs > button")
        removeSelections(dogs)
        clearSearch(filters)
    }

    function clearSearch(filters) {
        const search = filters == null ? null : filters.querySelector("input.search")
        if (search) {
            search.value = ""
        }
    }

    function removeSelections(nodes) {
        if (nodes) {
            for (let i = 0; i < nodes.length; i++) {
                nodes[i].classList.remove("active")
            }
        }
    }


    function handleSelectionClick(node, exclusive) {
        if (node.classList.contains("active")) {
            node.classList.remove("active")
        } else {
            node.classList.add("active")
            if (exclusive) {
                // remove active from peers
                const children = node.parentElement.children
                for (let i = 0; i < children.length; i++) {
                    if (children[i] != node) {
                        children[i].classList.remove("active")
                    }
                }
            }
        }
        const trailfinder = node.closest(".trailfinder")
        filterResults(trailfinder)
    }

    function addSelectionEvents(nodes) {
        if (nodes) {
            for (let i = 0; i < nodes.length; i++) {
                nodes[i].addEventListener("click", function (e) {
                    e.preventDefault()
                    let exclusive = nodes[i].parentElement.classList.contains("exclusive")
                    handleSelectionClick(nodes[i], exclusive)
                })
            }
        }
    }


    function addClearEvent(trailfinder, filters) {
        const clearBtn = trailfinder.querySelector(".clear")
        clearBtn.addEventListener("click", function () {
            clearFilters(filters)
            filterResults(trailfinder)
        })

    }

    function addSearchEvent(trailfinder, filters) {
        const search = filters == null ? null : filters.querySelector("input.search")
        if (search) {
            search.addEventListener("keyup", () => {
                filterResults(trailfinder)
            })
        }
    }

    function addRefineOpenClose(trailfinder) {
        const close = trailfinder.querySelector("button.close")
        const refine = trailfinder.querySelector("button.refine")
        const filters = trailfinder.querySelector(".filters")
        close.addEventListener("click", function () {
            filters.classList.remove("open")
        })
        refine.addEventListener("click", function () {
            filters.classList.add("open")
        })
    }

    function getMode(trailfinder) {
        let result = "list"
        const modeInputs = trailfinder.querySelectorAll("input[name='mode']")
        for (let i = 0; i < modeInputs.length; i++) {
            if (modeInputs[i].checked) {
                result = modeInputs[i].value
            }
        }
        return result
    }

    function setMode(trailfinder) {
        //console.log("setting mode", trailfinder.map)
        let mode = getMode(trailfinder)
        const trails = trailfinder.querySelector(".trails")
        const map = trailfinder.querySelector(".map")
        if (mode == "list") {
            trails.classList.remove("hide")
            map.classList.add("hide")
        } else {
            // mode == "map"
            trails.classList.add("hide")
            map.classList.remove("hide")
            trailfinder.map.setTrails(trails)

        }
        filterResults(trailfinder)
    }

    function addSetModeEvents(trailfinder) {
        const modeInputs = trailfinder.querySelectorAll("input[name='mode']")
        for (let i = 0; i < modeInputs.length; i++) {
            modeInputs[i].addEventListener("change", function () {
                setMode(trailfinder)
            })
        }
    }

    function addHandlers(trailfinder) {
        const filters = trailfinder.querySelector(".filters")
        const distances = filters == null ? null : filters.querySelectorAll(".distances > button")
        addSelectionEvents(distances)
        const difficulties = filters == null ? null : filters.querySelectorAll(".difficulties > button")
        addSelectionEvents(difficulties)
        const uses = filters == null ? null : filters.querySelectorAll(".uses > button")
        addSelectionEvents(uses)
        const locations = filters == null ? null : filters.querySelectorAll(".locations > button")
        addSelectionEvents(locations)
        const dogs = filters == null ? null : filters.querySelectorAll(".dogs > button")
        addSelectionEvents(dogs)

        addClearEvent(trailfinder, filters)
        addSearchEvent(trailfinder, filters)
        addRefineOpenClose(trailfinder)
        addSetModeEvents(trailfinder)
    }

    function handleMap(trailfinder) {
        const mapElement = trailfinder.querySelector(".map")
        if (!mapElement) {
            return
        }
        const trailsEl = trailfinder.querySelector(".trails")
        const trails = trailsEl.querySelectorAll(".trail")

        const el = document.createElement('trail-map');
        el.trails = trails
        mapElement.appendChild(el);
        trailfinder.map = el

    }

    const trailfinders = document.querySelectorAll(".trailfinder")
    if (trailfinders) {
        for (let i = 0; i < trailfinders.length; i++) {
            const trailfinder = trailfinders[i]
            handleMap(trailfinder)
            addHandlers(trailfinder)
            //filterResults(trailfinder)

        }


    }
})();